import { combineReducers, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { keyById } from '@mews/fp';

import { ServiceDocument, ServiceDocuments } from './types';

const dataInitialState: ServiceDocuments['data'] = {};

interface SetServiceDocumentsResponse {
    serviceDocuments: ServiceDocument[];
}

const serviceDocumentsDataSlice = createSlice({
    name: 'serviceDocumentsData',
    initialState: dataInitialState,
    reducers: {
        setServiceDocuments: (
            state,
            { payload: { serviceDocuments } }: PayloadAction<SetServiceDocumentsResponse>
        ) => ({
            ...state,
            ...keyById(serviceDocuments),
        }),
    },
});

const serviceDocumentsSlice = combineReducers({
    data: serviceDocumentsDataSlice.reducer,
});

const { setServiceDocuments } = serviceDocumentsDataSlice.actions;

export { setServiceDocuments, serviceDocumentsSlice };
